import classNames from 'classnames';
import React from 'react';
import { useLocation } from 'react-router-dom';
import * as S from './styles';

export type Breadcrumb = {
  label: string;
  to: string;
  state?: any;
};

type Props = {
  breadcrumbs: Breadcrumb[];
  className?: string;
};

const UDBreadcrumbs = (props: Props) => {
  const { breadcrumbs, className } = props;
  const location = useLocation();
  return (
    <div className={classNames('flex items-center flex flex-row', className)}>
      {breadcrumbs.map((breadcrumb, index) => (
        <S.Breadcrumb
          key={index}
          to={breadcrumb.to}
          state={breadcrumb.state}
          className={classNames('text', {
            active: location.pathname === breadcrumb.to,
          })}
        >
          {breadcrumb.label}
        </S.Breadcrumb>
      ))}
    </div>
  );
};

export default UDBreadcrumbs;
